import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { fetch_walker_details, save_walker_details } from './api';
import type { WalkerDetailsRequest } from './types';

const KEY = ['module-details', 'walker'] as const;

export function use_save_walker_details() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (input: WalkerDetailsRequest) => save_walker_details(input),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['onboarding', 'draft'] });
      qc.invalidateQueries({ queryKey: KEY });
    },
  });
}

export function use_walker_details(options?: { enabled?: boolean }) {
  return useQuery({
    queryKey: KEY,
    queryFn: fetch_walker_details,
    staleTime: 0,
    retry: 0,
    enabled: options?.enabled ?? true,
  });
}
